import React, { useEffect, useState } from 'react'
import { AuthModel } from '../../../utils/interfaces'
import { ProjectProps } from '../Project'
import { useTranslation } from 'react-i18next'
import { Admin, updateItem } from '../../../api/API'
import { tables } from '../../../utils/constants'
import Loading from '../../../components/Loading'
import { Input, Textarea } from '../../../components/Input'
import { BoldHeader3 } from '../../../components/General'

interface Props extends ProjectProps {
  auth: AuthModel
  setAuth: React.Dispatch<React.SetStateAction<AuthModel | null>>
}

const Template = ({ auth, setAuth, ...props }: Props) => {

  const { t } = useTranslation();
  const [option, setOption] = useState<"CONFIRM_WITH_CODE" | "CONFIRM_WITH_LINK">(auth.auth.verificationMessage!.DefaultEmailOption);
  const [subject, setSubject] = useState<string>(auth.auth.verificationMessage!.Subject);
  const [message, setMessage] = useState<string>(auth.auth.verificationMessage!.Message);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  useEffect(() => {
    setOption(auth.auth.verificationMessage!.DefaultEmailOption);
    setSubject(auth.auth.verificationMessage!.Subject);
    setMessage(auth.auth.verificationMessage!.Message);
  }, [auth.auth.verificationMessage]);

  useEffect(() => {
    if (option === auth.auth.verificationMessage!.DefaultEmailOption) {
      setMessage(auth.auth.verificationMessage!.Message);
    } else {
      setMessage(option === 'CONFIRM_WITH_CODE' ? t('project.auth.message.template.code') : t('project.auth.message.template.link'));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [option, auth.auth.verificationMessage]);

  // check if the template is the same
  const isSameTemplate = () => {
    return auth.auth.verificationMessage!.DefaultEmailOption === option &&
      auth.auth.verificationMessage!.Subject === subject &&
      auth.auth.verificationMessage!.Message === message;
  }

  // check if the template is valid
  const isValidTemplate = () => {
    if (!message || !subject) return false;
    if (option === 'CONFIRM_WITH_CODE') {
      return message.includes('{####}');
    }
    return message.includes('{##Verify Email##}');
  }
  
  const saveUpdate = async () => {
    setIsSaving(true);
    await Admin.updateEmailTemplate(auth.auth.userPoolId, option, subject, message);
    const newAuth: AuthModel = { ...auth, auth: { ...auth.auth, verificationMessage: { DefaultEmailOption: option, Subject: subject, Message: message } } };
    setAuth(newAuth);
    await updateItem(tables.auths, newAuth.id, { auth: newAuth.auth });
    setIsSaving(false);
  }

  
  return (
    <div className='flex-1 p-2 flex flex-col'>
      <div className='flex items-center justify-between flex-wrap mt-2'>
        <BoldHeader3>{t('project.auth.template')}</BoldHeader3>
      </div>
      <div className='flex flex-col flex-1 overflow-auto mt-2'>
        <div className='flex flex-col'>
          {/* <div className='mt-2 flex text-sm'>
            <div onClick={() => setOption('CONFIRM_WITH_CODE')} className='flex items-center cursor-pointer'><button className={`text-white h-4 w-4 flex items-center justify-center rounded border mr-2 ${option === 'CONFIRM_WITH_CODE' ? 'bg-primary border-primary' : 'bg-none'}`}><i className='fa-solid fa-check text-xs' /></button>{t('project.auth.template.confirm-with-code')}</div>
            <div onClick={() => setOption('CONFIRM_WITH_LINK')} className='flex items-center cursor-pointer ml-8'><button className={`text-white h-4 w-4 flex items-center justify-center rounded border mr-2 ${option === 'CONFIRM_WITH_LINK' ? 'bg-primary border-primary' : 'bg-none'}`}><i className='fa-solid fa-check text-xs' /></button>{t('project.auth.template.confirm-with-link')}</div>
          </div> */}
          <div className='mt-2 flex flex-col'>
            <label className='text-xs text-gray-400 m-1'>{t('project.auth.template.subject')}</label>
            <Input value={subject} onChange={(e) => setSubject(e.target.value)} style={{ maxWidth: 400 }} textSize='small' />
          </div>
          <div className='mt-4 flex flex-col'>
            <label className='text-xs text-gray-400 m-1'>{t('project.auth.template.message-with-placeholder', { placeholder: option === 'CONFIRM_WITH_CODE' ? '{####}' : '{##Verify Email##}' })}</label>
            <Textarea value={message} onChange={(e) => setMessage(e.target.value)} style={{ maxWidth: 400 }} textSize='small' />
          </div>
          <div className='mt-8'>
            <button onClick={saveUpdate} disabled={!isValidTemplate() || isSameTemplate() || isSaving} className='p-2 px-8 disabled:bg-gray-300 bg-primary rounded-lg text-sm text-white'>{isSaving ? <Loading /> : t('general.save')}</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Template